import { QUERY_KEYS } from '@24i/nxg-sdk-photon';
import { PersistedClient } from 'react-query/persistQueryClient-experimental';

export const handlePersistStorage = (
    client: PersistedClient,
    persistorKeys: (QUERY_KEYS | string)[] = []
) => {
    const filteredQueries = client.clientState.queries.filter((query) => {
        const key = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
        return persistorKeys.includes(key as QUERY_KEYS);
    });

    return JSON.stringify({
        ...client,
        clientState: {
            ...client.clientState,
            queries: filteredQueries,
        },
    });
};
